module.exports = __webpack_public_path__ + "static/media/AnalogClock.b4032241.png";